import styled, { CSSProperties, css } from 'styled-components';

import { donedealBreakpoints } from 'styled-system';

const ContainerStyles = css<{
  justifyContent?: CSSProperties['justifyContent'];
}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  /* Use a function to access props. Defaulting to 'space-between' */
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};

  ${donedealBreakpoints.media.medium} {
    // The height of the modal is expected to be greater than the size denoted by its contents
    min-height: 658px;
  }
`;

export const Container = styled.div`
  ${ContainerStyles}
`;

export const FormContainer = styled.form`
  ${ContainerStyles}
`;
